import { Fragment, useState } from "react"
import { v4 as uuid } from "uuid"

import { Combobox, Transition } from "@headlessui/react"
import { ChevronUpDownIcon } from "@heroicons/react/20/solid"
import classNames from "classnames"

export default function CustomCombobox({
  items,
  displayValueFn = () => {},
  keyFn = () => {},
  onChange,
  testId = undefined,
}) {
  const id = testId || uuid()

  const [query, setQuery] = useState("")

  const filteredItems =
    query === ""
      ? items
      : items.filter((item) => {
          return displayValueFn(item)
            .toLowerCase()
            .includes(query.toLowerCase())
        })

  return (
    <div>
      <Combobox onChange={onChange}>
        <div className="relative mt-1">
          <div className="relative w-full cursor-default overflow-hidden border border-neutral-8 bg-white text-left focus:border-primary-4 focus:outline-none focus-visible:ring-2 focus-visible:ring-white focus-visible:ring-opacity-75 focus-visible:ring-offset-2 focus-visible:ring-offset-primary-4 sm:text-sm">
            <Combobox.Button as="div">
              <Combobox.Input
                className="w-full border-none py-2 pl-3 pr-10 text-sm leading-5 text-gray-900 focus:ring-0"
                displayValue={displayValueFn}
                onChange={(event) => setQuery(event.target.value)}
                placeholder={"Search for a field..."}
                id={`combobox-input-${id}`}
              />
            </Combobox.Button>
            <Combobox.Button className="absolute inset-y-0 right-0 flex items-center pr-2">
              <ChevronUpDownIcon
                className="h-5 w-5 text-gray-400"
                aria-hidden="true"
              />
            </Combobox.Button>
          </div>
          <Transition
            as={Fragment}
            leave="transition ease-in duration-100"
            leaveFrom="opacity-100"
            leaveTo="opacity-0"
            afterLeave={() => setQuery("")}
          >
            <Combobox.Options
              id={`combobox-results-${id}`}
              className="absolute mt-1 max-h-60 w-full overflow-x-auto rounded-md bg-white py-1 text-base shadow-lg ring-1 ring-black ring-opacity-5 focus:outline-none sm:text-sm"
            >
              {filteredItems.length === 0 && query !== "" ? (
                <div className="relative cursor-default select-none px-4 py-2 text-gray-700">
                  {`No items match '${query}'`}
                </div>
              ) : (
                filteredItems.map((item) => (
                  <Combobox.Option
                    key={keyFn(item)}
                    className={({ active }) =>
                      classNames(
                        "relative cursor-default select-none px-4 py-2",
                        {
                          "bg-primary-10 font-medium": active,
                        }
                      )
                    }
                    value={item}
                  >
                    <span className={"block truncate"}>
                      {displayValueFn(item)}
                    </span>
                  </Combobox.Option>
                ))
              )}
            </Combobox.Options>
          </Transition>
        </div>
      </Combobox>
    </div>
  )
}
